import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

// Cache-Buster
const addCacheBuster = (path) => {
  if (!path) return path;
  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}t=${Date.now()}`;
};

const Morotsmejeriet = () => {
  const { t } = useLanguage();

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl font-bold text-gray-800 mb-6">
              {t('morotsmejeriet.title')}
            </h2>
            <p className="text-lg text-gray-700 mb-8">
              {t('morotsmejeriet.intro')}
            </p>
            
            <div className="bg-white p-6 rounded-lg shadow-md mb-6">
              <h3 className="text-xl font-semibold text-primary-green mb-4">
                {t('morotsmejeriet.fermentationTitle')}
              </h3>
              <p className="text-gray-600 mb-4">
                {t('morotsmejeriet.fermentationText')}
              </p>
              <ul className="list-disc pl-5 space-y-2 text-gray-600 mb-4">
                {(t('morotsmejeriet.benefits', { returnObjects: true }) || []).map((benefit, index) => (
                  <li key={index}>{benefit}</li>
                ))}
              </ul>
              <p className="text-gray-600 italic">
                {t('morotsmejeriet.conclusion')}
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <img
              src={addCacheBuster('/images/mejeriet.webp')}
              alt={t('morotsmejeriet.imagePlaceholder')}
              className="w-full rounded-lg shadow-xl hover-scale"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Morotsmejeriet;